import React, { useState, useEffect } from "react";
import { deleteUserByAdmin } from "../../services/adminUserService";

const DeleteUserModal = ({ user, onClose, onSuccess }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setReason("");
    setError("");
  }, [user]);

  const handleDelete = async () => {
    setLoading(true);
    setError("");
    try {
      await deleteUserByAdmin(user.id, reason.trim());
      onSuccess(user);
    } catch (err) {
      setError(err.response?.data?.MESSAGE || "Failed to delete user. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (!loading && e.target === e.currentTarget) onClose();
  };

  return (
    <div style={overlay} onClick={handleOverlayClick} onKeyDown={(e) => !loading && e.key === "Escape" && onClose()}>
      <div style={modal}>
        <h3 style={{ marginTop: 0, marginBottom: "12px" }}>Delete User Account</h3>
        <p style={{ color: "#c0392b", marginBottom: "16px", fontSize: "14px" }}>
          ⚠️ This action is permanent and cannot be undone. All user data including bookings,
          subscriptions, and profile will be deleted.
        </p>
        <p style={{ marginBottom: "12px", fontSize: "14px" }}>
          <strong>User:</strong> {user.name || user.email}
        </p>
        <textarea
          placeholder="Reason for deletion (optional)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          disabled={loading}
          style={{ width: "100%", padding: "8px", boxSizing: "border-box", marginBottom: "8px", resize: "vertical" }}
        />
        {error && <p style={{ color: "#c0392b", fontSize: "13px", marginBottom: "8px" }}>{error}</p>}
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            style={{ background: "#c0392b", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "4px", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}
          >
            {loading ? "Deleting..." : "Delete Permanently"}
          </button>
        </div>
      </div>
    </div>
  );
};

const overlay = {
  position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
  background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
};

const modal = {
  background: "#fff", padding: "24px", borderRadius: "8px", width: "420px", maxWidth: "90vw",
};

export default DeleteUserModal;
